import { AppType } from '@/features/Dashboard/types';

export default function getMaxItemsForType(type: AppType | undefined) {
  switch (type) {
    case AppType.Spot:
      return 6;
    case AppType.FWD:
      return 2;
    case AppType.Seasonal:
      return 1;
    case AppType.Table:
      return 20;
    case AppType.Tiles:
      return 8;
    default:
      return 0;
  }
}
